// @flow
import { commitMutation, graphql } from 'react-relay';

export const mutation = graphql`
  mutation CartUpdateEventIdMutation($input: CartUpdateEventIdInput!) {
    cartUpdateEventId(input: $input) {
      cart {
        id
        promoCodes {
          id
          code
        }
        eventId
        eventHostFirstName
      }
      cartV2 {
        id
        promoCodes {
          id
          code
        }
        eventId
        eventHostFirstName
      }
      user {
        id
        ...NavbarComponent_user
        preferredCustomerCeoAccountId
        shoppingWithCeoUser {
          id
          publicId
          userId
          firstName
          lastName
          profile {
            id
            image
            city
            state
            zip
          }
        }
      }
    }
  }
`;

function commit({
  environment,
  eventId,
  reassignSatelliteIfPossible,
  onCompleted,
  onError,
}) {
  return commitMutation(environment, {
    mutation,
    variables: { input: { eventId, reassignSatelliteIfPossible } },
    onCompleted,
    onError,
  });
}

export default { commit };
